function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  //openDetailsElement.removeAttribute('open');
  //summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    //this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('button.header__icon--close').forEach(button => button.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.querySelectorAll('.mobile-facets__close').forEach(button => button.addEventListener('click', this.closeMenuDrawer.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      if(element.nextElementSibling){
        element.setAttribute('aria-controls', element.nextElementSibling.id);
      }
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      if(!isOpen) this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event) {
    const elementToFocus = event.currentTarget;
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    //window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    //window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    console.log('loadContent');
    //window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
let scroolEv = true;

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul.slider');
    this.sliderItems = this.querySelectorAll('.slider__slide');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.dots = this.querySelectorAll('.slider-dots li');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.asNavForClass = this.getAttribute('data-asNavFor');
    this.asNavForIndex = 0;
    if(this.asNavForClass){
      this.asNavForEl = document.querySelector(this.asNavForClass);
      this.asNavForSlider = this.asNavForEl.querySelector('ul');
      this.asNavForItems = this.asNavForEl.querySelectorAll('li');
      this.asNavForprevButton = this.asNavForEl.querySelector('button[name="previous"]');
      this.asNavFornextButton = this.asNavForEl.querySelector('button[name="next"]');
      this.changeThumbnail();
    }

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  changeThumbnail(){
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    window.addEventListener('scroll',(event) => {
      if(window.innerWidth >= 990 ){
        let scroll = scrollY;
        if(scroll >= this.slider.offsetTop && scroll <= this.slider.offsetTop + (this.sliderLastItem.offsetTop + this.sliderLastItem.clientHeight) && scroolEv){

          this.sliderItems.forEach(elem => {
            if(scroll >= (elem.offsetTop - 20) && scroll <= (elem.offsetTop + elem.clientHeight / 2) ){
              let curIndex = elem.getAttribute('data-index');
              if (this.asNavForIndex != curIndex){
                this.asNavForItems.forEach(el=>el.classList.remove("current-slide"));
                this.asNavForItems[curIndex].classList.add('current-slide');

                if(this.asNavForIndex < curIndex){
                  this.asNavForSlider.scrollTo({
                    top: this.asNavForSlider.scrollTop + this.asNavForItems[0].clientHeight
                  });
                }else if(this.asNavForIndex > curIndex){
                  this.asNavForSlider.scrollTo({
                    top: this.asNavForSlider.scrollTop - this.asNavForItems[0].clientHeight
                  });
                }

                this.asNavForIndex = curIndex;
                if (this.asNavForIndex == 0) {
                  this.asNavForprevButton.setAttribute('disabled', true);
                } else {
                  this.asNavForprevButton.removeAttribute('disabled');
                }
                if (this.asNavForIndex == (this.sliderItems.length - 1)) {
                  this.asNavFornextButton.setAttribute('disabled', true);
                } else {
                  this.asNavFornextButton.removeAttribute('disabled');
                }

                return;
              }
            }
          });
        }
      }
    });
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.dots.forEach(el=>el.classList.remove("current-dot"));
    this.dots[this.currentPage - 1].classList.add('current-dot');

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class ThumbnailsSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.slidesPerPage = +this.getAttribute('data-show');
    this.asNavForClass = this.getAttribute('data-asNavFor');
    if(this.asNavForClass){
      this.asNavForEl = document.querySelector(this.asNavForClass);
    }

    this.currentSlide = 0;
    if (!this.slider || !this.nextButton) return;
    if(document.querySelector('.sticky-header')){
      this.parentElement.style.top = (document.querySelector('.header-wrapper').offsetHeight + 10) + 'px';
    }else{
      this.parentElement.style.top = '15px';
    }

    this.sliderItems.forEach(el => el.addEventListener('click', this.onChange.bind(this)));
    this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
    this.nextButton.addEventListener('click', this.onNextClick.bind(this));
    const resizeObserver = new ResizeObserver(entries => this.initThumbnailPages());
    resizeObserver.observe(this.slider);
  }

  initThumbnailPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientHeight > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    let header_height = document.querySelector('.header').clientHeight;
    if(sliderItemsToShow[0] && sliderItemsToShow[0].clientHeight){
      if((sliderItemsToShow[0].clientHeight * this.slidesPerPage + 140) > (window.innerHeight - header_height - 140)){
        this.slidesPerPage = Math.floor((window.innerHeight - header_height - 140) / sliderItemsToShow[0].clientHeight);
      }
    }else {
      return;
    }

    if (sliderItemsToShow.length === 0) return;
    this.totalSlides = sliderItemsToShow.length - 1;
    this.slider.style.height = (sliderItemsToShow[0].clientHeight * this.slidesPerPage) - 5 + 'px';
  }

  updateThumbnail(event) {
    scroolEv = false;
    this.sliderItems.forEach(el=>el.classList.remove("current-slide"));
    this.sliderItems[this.currentSlide].classList.add('current-slide');
    if (this.currentSlide === 0) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.currentSlide === this.totalSlides) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    if(this.asNavForClass){
      let pos_asNavFor = this.asNavForEl.querySelector('.slider__slide[data-index="'+ this.currentSlide +'"]').offsetTop + 22;
      window.scrollTo({
        top: pos_asNavFor,
        behavior: "smooth"
      });
      let position = null
      const checkIfScrollIsStatic = setInterval(() => {
        if (pos_asNavFor === window.scrollY) {
          clearInterval(checkIfScrollIsStatic)
          scroolEv = true;
        }
        position = window.scrollY
      }, 50)
    }
  }

  onChange(event) {
    event.preventDefault();
    let curIndex = +this.slider.querySelector('.slider__slide.current-slide').getAttribute('data-index');
    this.currentSlide = +event.currentTarget.getAttribute('data-index');

    if(this.currentSlide < curIndex){
      this.slider.scrollTo({
        top: this.slider.scrollTop - this.sliderLastItem.clientHeight
      });
    }else if(this.currentSlide > curIndex){
      this.slider.scrollTo({
        top: this.slider.scrollTop + this.sliderLastItem.clientHeight
      });
    }
    this.updateThumbnail();
  }

  onPrevClick(event) {
    event.preventDefault();
    this.currentSlide = +this.slider.querySelector('.slider__slide.current-slide').getAttribute('data-index');
    if (this.currentSlide >= 1) {
      this.currentSlide -= 1;
      let slideScrollPosition = this.slider.scrollTop - this.sliderLastItem.clientHeight;
      this.slider.scrollTo({
        top: slideScrollPosition
      });
      this.updateThumbnail();
    }
  }
  onNextClick(event) {
    event.preventDefault();
    this.currentSlide = +this.slider.querySelector('.slider__slide.current-slide').getAttribute('data-index');
    if (this.currentSlide < this.totalSlides) {
      this.currentSlide += 1;
      let slideScrollPosition = this.slider.scrollTop + this.sliderLastItem.clientHeight;
      this.slider.scrollTo({
        top: slideScrollPosition
      });
      this.updateThumbnail();
    }
  }
}

customElements.define('thumbnails-slider-component', ThumbnailsSliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        Currency.convertAll(theme.settings.defaultShopCurrency, getCookie("currentCurrency"));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class LocationPopup extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init(){
    /*==========    GeoIP  ===========*/
    const geoAPIRequest =`/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&country[exclude]=${theme.settings.countryCode}&currency[enabled]=true&currency[exclude]=${theme.settings.defaultShopCurrency}&language[enabled]=false&`
    let $this = this;
    const localeBar = getCookie("locale_bar_hidden");
    /* Default currency */

    this.shopCurrency = theme.settings.defaultShopCurrency;
    this.currencySelector = document.querySelector(".site-nav__currency .currencies");
    this.backdrop = document.querySelector(".recommendation-modal__backdrop");
    if(!localeBar) {
      fetch(geoAPIRequest, {
        method: "GET"
      })
        .then((response) => response.json())
        .then((suggestions) =>   {
          if (!suggestions) return;
          let current_country = suggestions.detected_values.country.name;
          let current_code = suggestions.detected_values.country.handle;
          let current_simbol = '';
          let currenciesByCountryCode = JSON.parse("{\"AC\":{\"symbol\":\"£\",\"isoCode\":\"SHP\"},\"AD\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"AE\":{\"symbol\":null,\"isoCode\":\"AED\"},\"AF\":{\"symbol\":\"؋\",\"isoCode\":\"AFN\"},\"AG\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"AI\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"AL\":{\"symbol\":null,\"isoCode\":\"ALL\"},\"AM\":{\"symbol\":\"֏\",\"isoCode\":\"AMD\"},\"AO\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"AR\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"AT\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"AU\":{\"symbol\":\"\$\",\"isoCode\":\"AUD\"},\"AW\":{\"symbol\":null,\"isoCode\":\"AWG\"},\"AX\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"AZ\":{\"symbol\":\"₼\",\"isoCode\":\"AZN\"},\"BA\":{\"symbol\":\"KM\",\"isoCode\":\"BAM\"},\"BB\":{\"symbol\":\"\$\",\"isoCode\":\"BBD\"},\"BD\":{\"symbol\":\"৳\",\"isoCode\":\"BDT\"},\"BE\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"BF\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"BG\":{\"symbol\":null,\"isoCode\":\"BGN\"},\"BH\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"BI\":{\"symbol\":null,\"isoCode\":\"BIF\"},\"BJ\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"BL\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"BM\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"BN\":{\"symbol\":\"\$\",\"isoCode\":\"BND\"},\"BO\":{\"symbol\":\"Bs\",\"isoCode\":\"BOB\"},\"BQ\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"BR\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"BS\":{\"symbol\":\"\$\",\"isoCode\":\"BSD\"},\"BT\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"BW\":{\"symbol\":\"P\",\"isoCode\":\"BWP\"},\"BY\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"BZ\":{\"symbol\":\"\$\",\"isoCode\":\"BZD\"},\"CA\":{\"symbol\":\"\$\",\"isoCode\":\"CAD\"},\"CC\":{\"symbol\":\"\$\",\"isoCode\":\"AUD\"},\"CD\":{\"symbol\":null,\"isoCode\":\"CDF\"},\"CF\":{\"symbol\":\"FCFA\",\"isoCode\":\"XAF\"},\"CG\":{\"symbol\":\"FCFA\",\"isoCode\":\"XAF\"},\"CH\":{\"symbol\":null,\"isoCode\":\"CHF\"},\"CI\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"CK\":{\"symbol\":\"\$\",\"isoCode\":\"NZD\"},\"CL\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"CM\":{\"symbol\":\"FCFA\",\"isoCode\":\"XAF\"},\"CN\":{\"symbol\":\"¥\",\"isoCode\":\"CNY\"},\"CO\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"CR\":{\"symbol\":\"₡\",\"isoCode\":\"CRC\"},\"CV\":{\"symbol\":null,\"isoCode\":\"CVE\"},\"CW\":{\"symbol\":null,\"isoCode\":\"ANG\"},\"CX\":{\"symbol\":\"\$\",\"isoCode\":\"AUD\"},\"CY\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"CZ\":{\"symbol\":\"Kč\",\"isoCode\":\"CZK\"},\"DE\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"DJ\":{\"symbol\":null,\"isoCode\":\"DJF\"},\"DK\":{\"symbol\":\"kr\",\"isoCode\":\"DKK\"},\"DM\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"DO\":{\"symbol\":\"\$\",\"isoCode\":\"DOP\"},\"DZ\":{\"symbol\":null,\"isoCode\":\"DZD\"},\"EC\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"EE\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"EG\":{\"symbol\":\"E£\",\"isoCode\":\"EGP\"},\"EH\":{\"symbol\":null,\"isoCode\":\"MAD\"},\"ER\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"ES\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"ET\":{\"symbol\":null,\"isoCode\":\"ETB\"},\"FI\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"FJ\":{\"symbol\":\"\$\",\"isoCode\":\"FJD\"},\"FK\":{\"symbol\":\"£\",\"isoCode\":\"FKP\"},\"FO\":{\"symbol\":\"kr\",\"isoCode\":\"DKK\"},\"FR\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"GA\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"GB\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"GD\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"GE\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"GF\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"GG\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"GH\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"GI\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"GL\":{\"symbol\":\"kr\",\"isoCode\":\"DKK\"},\"GM\":{\"symbol\":null,\"isoCode\":\"GMD\"},\"GN\":{\"symbol\":\"FG\",\"isoCode\":\"GNF\"},\"GP\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"GQ\":{\"symbol\":\"FCFA\",\"isoCode\":\"XAF\"},\"GR\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"GS\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"GT\":{\"symbol\":\"Q\",\"isoCode\":\"GTQ\"},\"GW\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"GY\":{\"symbol\":\"\$\",\"isoCode\":\"GYD\"},\"HK\":{\"symbol\":\"HK\$\",\"isoCode\":\"HKD\"},\"HN\":{\"symbol\":\"L\",\"isoCode\":\"HNL\"},\"HR\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"HT\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"HU\":{\"symbol\":\"Ft\",\"isoCode\":\"HUF\"},\"ID\":{\"symbol\":\"Rp\",\"isoCode\":\"IDR\"},\"IE\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"IL\":{\"symbol\":\"₪\",\"isoCode\":\"ILS\"},\"IM\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"IN\":{\"symbol\":\"₹\",\"isoCode\":\"INR\"},\"IO\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"IQ\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"IS\":{\"symbol\":\"kr\",\"isoCode\":\"ISK\"},\"IT\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"JE\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"JM\":{\"symbol\":\"\$\",\"isoCode\":\"JMD\"},\"JO\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"JP\":{\"symbol\":\"¥\",\"isoCode\":\"JPY\"},\"KE\":{\"symbol\":null,\"isoCode\":\"KES\"},\"KG\":{\"symbol\":null,\"isoCode\":\"KGS\"},\"KH\":{\"symbol\":\"៛\",\"isoCode\":\"KHR\"},\"KI\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"KM\":{\"symbol\":\"CF\",\"isoCode\":\"KMF\"},\"KN\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"KR\":{\"symbol\":\"₩\",\"isoCode\":\"KRW\"},\"KW\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"KY\":{\"symbol\":\"\$\",\"isoCode\":\"KYD\"},\"KZ\":{\"symbol\":\"₸\",\"isoCode\":\"KZT\"},\"LA\":{\"symbol\":\"₭\",\"isoCode\":\"LAK\"},\"LB\":{\"symbol\":\"L£\",\"isoCode\":\"LBP\"},\"LC\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"LI\":{\"symbol\":null,\"isoCode\":\"CHF\"},\"LK\":{\"symbol\":\"Rs\",\"isoCode\":\"LKR\"},\"LR\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"LS\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"LT\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"LU\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"LV\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"LY\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"MA\":{\"symbol\":null,\"isoCode\":\"MAD\"},\"MC\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"MD\":{\"symbol\":null,\"isoCode\":\"MDL\"},\"ME\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"MF\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"MG\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"MK\":{\"symbol\":null,\"isoCode\":\"MKD\"},\"ML\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"MM\":{\"symbol\":\"K\",\"isoCode\":\"MMK\"},\"MN\":{\"symbol\":\"₮\",\"isoCode\":\"MNT\"},\"MO\":{\"symbol\":null,\"isoCode\":\"MOP\"},\"MQ\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"MR\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"MS\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"MT\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"MU\":{\"symbol\":\"Rs\",\"isoCode\":\"MUR\"},\"MV\":{\"symbol\":null,\"isoCode\":\"MVR\"},\"MW\":{\"symbol\":null,\"isoCode\":\"MWK\"},\"MX\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"MY\":{\"symbol\":\"RM\",\"isoCode\":\"MYR\"},\"MZ\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"NA\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"NC\":{\"symbol\":\"CFPF\",\"isoCode\":\"XPF\"},\"NE\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"NF\":{\"symbol\":\"\$\",\"isoCode\":\"AUD\"},\"NG\":{\"symbol\":\"₦\",\"isoCode\":\"NGN\"},\"NI\":{\"symbol\":\"C\$\",\"isoCode\":\"NIO\"},\"NL\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"NO\":{\"symbol\":\"kr\",\"isoCode\":\"NOK\"},\"NP\":{\"symbol\":\"Rs\",\"isoCode\":\"NPR\"},\"NR\":{\"symbol\":\"\$\",\"isoCode\":\"AUD\"},\"NU\":{\"symbol\":\"\$\",\"isoCode\":\"NZD\"},\"NZ\":{\"symbol\":\"\$\",\"isoCode\":\"NZD\"},\"OM\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"PA\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"PE\":{\"symbol\":null,\"isoCode\":\"PEN\"},\"PF\":{\"symbol\":\"CFPF\",\"isoCode\":\"XPF\"},\"PG\":{\"symbol\":null,\"isoCode\":\"PGK\"},\"PH\":{\"symbol\":\"₱\",\"isoCode\":\"PHP\"},\"PK\":{\"symbol\":\"Rs\",\"isoCode\":\"PKR\"},\"PL\":{\"symbol\":\"zł\",\"isoCode\":\"PLN\"},\"PM\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"PN\":{\"symbol\":\"\$\",\"isoCode\":\"NZD\"},\"PS\":{\"symbol\":\"₪\",\"isoCode\":\"ILS\"},\"PT\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"PY\":{\"symbol\":\"₲\",\"isoCode\":\"PYG\"},\"QA\":{\"symbol\":null,\"isoCode\":\"QAR\"},\"RE\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"RO\":{\"symbol\":\"lei\",\"isoCode\":\"RON\"},\"RS\":{\"symbol\":null,\"isoCode\":\"RSD\"},\"RU\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"RW\":{\"symbol\":\"RF\",\"isoCode\":\"RWF\"},\"SA\":{\"symbol\":null,\"isoCode\":\"SAR\"},\"SB\":{\"symbol\":\"\$\",\"isoCode\":\"SBD\"},\"SC\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"SD\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"SE\":{\"symbol\":\"kr\",\"isoCode\":\"SEK\"},\"SG\":{\"symbol\":\"\$\",\"isoCode\":\"SGD\"},\"SH\":{\"symbol\":\"£\",\"isoCode\":\"SHP\"},\"SI\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"SJ\":{\"symbol\":\"kr\",\"isoCode\":\"NOK\"},\"SK\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"SL\":{\"symbol\":null,\"isoCode\":\"SLL\"},\"SM\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"SN\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"SO\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"SR\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"SS\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"ST\":{\"symbol\":null,\"isoCode\":\"STD\"},\"SV\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"SX\":{\"symbol\":null,\"isoCode\":\"ANG\"},\"SZ\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"TA\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"TC\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"TD\":{\"symbol\":\"FCFA\",\"isoCode\":\"XAF\"},\"TF\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"TG\":{\"symbol\":\"F CFA\",\"isoCode\":\"XOF\"},\"TH\":{\"symbol\":\"฿\",\"isoCode\":\"THB\"},\"TJ\":{\"symbol\":null,\"isoCode\":\"TJS\"},\"TK\":{\"symbol\":\"\$\",\"isoCode\":\"NZD\"},\"TL\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"TM\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"TN\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"TO\":{\"symbol\":\"T\$\",\"isoCode\":\"TOP\"},\"TR\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"TT\":{\"symbol\":\"\$\",\"isoCode\":\"TTD\"},\"TV\":{\"symbol\":\"\$\",\"isoCode\":\"AUD\"},\"TW\":{\"symbol\":\"\$\",\"isoCode\":\"TWD\"},\"TZ\":{\"symbol\":null,\"isoCode\":\"TZS\"},\"UA\":{\"symbol\":\"₴\",\"isoCode\":\"UAH\"},\"UG\":{\"symbol\":null,\"isoCode\":\"UGX\"},\"UM\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"US\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"UY\":{\"symbol\":\"\$\",\"isoCode\":\"UYU\"},\"UZ\":{\"symbol\":null,\"isoCode\":\"UZS\"},\"VA\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"VC\":{\"symbol\":\"\$\",\"isoCode\":\"XCD\"},\"VE\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"VG\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"},\"VN\":{\"symbol\":\"₫\",\"isoCode\":\"VND\"},\"VU\":{\"symbol\":null,\"isoCode\":\"VUV\"},\"WF\":{\"symbol\":\"CFPF\",\"isoCode\":\"XPF\"},\"WS\":{\"symbol\":null,\"isoCode\":\"WST\"},\"XK\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"YE\":{\"symbol\":null,\"isoCode\":\"YER\"},\"YT\":{\"symbol\":\"€\",\"isoCode\":\"EUR\"},\"ZA\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"ZM\":{\"symbol\":\"£\",\"isoCode\":\"GBP\"},\"ZW\":{\"symbol\":\"\$\",\"isoCode\":\"USD\"}}")
          let data_countries = JSON.parse("{\"AC\":{\"country_name\":\"Ascension Island\",\"currency_code\":\"SHP\",\"currency_sign\":\"£\"},\"AD\":{\"country_name\":\"Andorra\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"AE\":{\"country_name\":\"United Arab Emirates\",\"currency_code\":\"AED\",\"currency_sign\":null},\"AF\":{\"country_name\":\"Afghanistan\",\"currency_code\":\"AFN\",\"currency_sign\":\"؋\"},\"AG\":{\"country_name\":\"Antigua & Barbuda\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"AI\":{\"country_name\":\"Anguilla\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"AL\":{\"country_name\":\"Albania\",\"currency_code\":\"ALL\",\"currency_sign\":null},\"AM\":{\"country_name\":\"Armenia\",\"currency_code\":\"AMD\",\"currency_sign\":\"֏\"},\"AO\":{\"country_name\":\"Angola\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"AR\":{\"country_name\":\"Argentina\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"AT\":{\"country_name\":\"Austria\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"AU\":{\"country_name\":\"Australia\",\"currency_code\":\"AUD\",\"currency_sign\":\"$\"},\"AW\":{\"country_name\":\"Aruba\",\"currency_code\":\"AWG\",\"currency_sign\":null},\"AX\":{\"country_name\":\"Åland Islands\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"AZ\":{\"country_name\":\"Azerbaijan\",\"currency_code\":\"AZN\",\"currency_sign\":\"₼\"},\"BA\":{\"country_name\":\"Bosnia & Herzegovina\",\"currency_code\":\"BAM\",\"currency_sign\":\"KM\"},\"BB\":{\"country_name\":\"Barbados\",\"currency_code\":\"BBD\",\"currency_sign\":\"$\"},\"BD\":{\"country_name\":\"Bangladesh\",\"currency_code\":\"BDT\",\"currency_sign\":\"৳\"},\"BE\":{\"country_name\":\"Belgium\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"BF\":{\"country_name\":\"Burkina Faso\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"BG\":{\"country_name\":\"Bulgaria\",\"currency_code\":\"BGN\",\"currency_sign\":null},\"BH\":{\"country_name\":\"Bahrain\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"BI\":{\"country_name\":\"Burundi\",\"currency_code\":\"BIF\",\"currency_sign\":null},\"BJ\":{\"country_name\":\"Benin\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"BL\":{\"country_name\":\"St. Barthélemy\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"BM\":{\"country_name\":\"Bermuda\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"BN\":{\"country_name\":\"Brunei\",\"currency_code\":\"BND\",\"currency_sign\":\"$\"},\"BO\":{\"country_name\":\"Bolivia\",\"currency_code\":\"BOB\",\"currency_sign\":\"Bs\"},\"BQ\":{\"country_name\":\"Caribbean Netherlands\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"BR\":{\"country_name\":\"Brazil\",\"currency_code\":\"BRL\",\"currency_sign\":\"R$\"},\"BS\":{\"country_name\":\"Bahamas\",\"currency_code\":\"BSD\",\"currency_sign\":\"$\"},\"BT\":{\"country_name\":\"Bhutan\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"BW\":{\"country_name\":\"Botswana\",\"currency_code\":\"BWP\",\"currency_sign\":\"P\"},\"BY\":{\"country_name\":\"Belarus\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"BZ\":{\"country_name\":\"Belize\",\"currency_code\":\"BZD\",\"currency_sign\":\"$\"},\"CA\":{\"country_name\":\"Canada\",\"currency_code\":\"CAD\",\"currency_sign\":\"$\"},\"CC\":{\"country_name\":\"Cocos (Keeling) Islands\",\"currency_code\":\"AUD\",\"currency_sign\":\"$\"},\"CD\":{\"country_name\":\"Congo - Kinshasa\",\"currency_code\":\"CDF\",\"currency_sign\":null},\"CF\":{\"country_name\":\"Central African Republic\",\"currency_code\":\"XAF\",\"currency_sign\":\"FCFA\"},\"CG\":{\"country_name\":\"Congo - Brazzaville\",\"currency_code\":\"XAF\",\"currency_sign\":\"FCFA\"},\"CH\":{\"country_name\":\"Switzerland\",\"currency_code\":\"CHF\",\"currency_sign\":null},\"CI\":{\"country_name\":\"Côte d’Ivoire\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"CK\":{\"country_name\":\"Cook Islands\",\"currency_code\":\"NZD\",\"currency_sign\":\"$\"},\"CL\":{\"country_name\":\"Chile\",\"currency_code\":\"CLP\",\"currency_sign\":\"$\"},\"CM\":{\"country_name\":\"Cameroon\",\"currency_code\":\"XAF\",\"currency_sign\":\"FCFA\"},\"CN\":{\"country_name\":\"China\",\"currency_code\":\"CNY\",\"currency_sign\":\"¥\"},\"CO\":{\"country_name\":\"Colombia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"CR\":{\"country_name\":\"Costa Rica\",\"currency_code\":\"CRC\",\"currency_sign\":\"₡\"},\"CV\":{\"country_name\":\"Cape Verde\",\"currency_code\":\"CVE\",\"currency_sign\":null},\"CW\":{\"country_name\":\"Curaçao\",\"currency_code\":\"ANG\",\"currency_sign\":null},\"CX\":{\"country_name\":\"Christmas Island\",\"currency_code\":\"AUD\",\"currency_sign\":\"$\"},\"CY\":{\"country_name\":\"Cyprus\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"CZ\":{\"country_name\":\"Czechia\",\"currency_code\":\"CZK\",\"currency_sign\":\"Kč\"},\"DE\":{\"country_name\":\"Germany\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"DJ\":{\"country_name\":\"Djibouti\",\"currency_code\":\"DJF\",\"currency_sign\":null},\"DK\":{\"country_name\":\"Denmark\",\"currency_code\":\"DKK\",\"currency_sign\":\"kr\"},\"DM\":{\"country_name\":\"Dominica\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"DO\":{\"country_name\":\"Dominican Republic\",\"currency_code\":\"DOP\",\"currency_sign\":\"$\"},\"DZ\":{\"country_name\":\"Algeria\",\"currency_code\":\"DZD\",\"currency_sign\":null},\"EC\":{\"country_name\":\"Ecuador\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"EE\":{\"country_name\":\"Estonia\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"EG\":{\"country_name\":\"Egypt\",\"currency_code\":\"EGP\",\"currency_sign\":\"E£\"},\"EH\":{\"country_name\":\"Western Sahara\",\"currency_code\":\"MAD\",\"currency_sign\":null},\"ER\":{\"country_name\":\"Eritrea\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"ES\":{\"country_name\":\"Spain\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"ET\":{\"country_name\":\"Ethiopia\",\"currency_code\":\"ETB\",\"currency_sign\":null},\"FI\":{\"country_name\":\"Finland\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"FJ\":{\"country_name\":\"Fiji\",\"currency_code\":\"FJD\",\"currency_sign\":\"$\"},\"FK\":{\"country_name\":\"Falkland Islands\",\"currency_code\":\"FKP\",\"currency_sign\":\"£\"},\"FO\":{\"country_name\":\"Faroe Islands\",\"currency_code\":\"DKK\",\"currency_sign\":\"kr\"},\"FR\":{\"country_name\":\"France\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"GA\":{\"country_name\":\"Gabon\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"GB\":{\"country_name\":\"United Kingdom\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"GD\":{\"country_name\":\"Grenada\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"GE\":{\"country_name\":\"Georgia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"GF\":{\"country_name\":\"French Guiana\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"GG\":{\"country_name\":\"Guernsey\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"GH\":{\"country_name\":\"Ghana\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"GI\":{\"country_name\":\"Gibraltar\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"GL\":{\"country_name\":\"Greenland\",\"currency_code\":\"DKK\",\"currency_sign\":\"kr\"},\"GM\":{\"country_name\":\"Gambia\",\"currency_code\":\"GMD\",\"currency_sign\":null},\"GN\":{\"country_name\":\"Guinea\",\"currency_code\":\"GNF\",\"currency_sign\":\"FG\"},\"GP\":{\"country_name\":\"Guadeloupe\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"GQ\":{\"country_name\":\"Equatorial Guinea\",\"currency_code\":\"XAF\",\"currency_sign\":\"FCFA\"},\"GR\":{\"country_name\":\"Greece\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"GS\":{\"country_name\":\"South Georgia & South Sandwich Islands\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"GT\":{\"country_name\":\"Guatemala\",\"currency_code\":\"GTQ\",\"currency_sign\":\"Q\"},\"GW\":{\"country_name\":\"Guinea-Bissau\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"GY\":{\"country_name\":\"Guyana\",\"currency_code\":\"GYD\",\"currency_sign\":\"$\"},\"HK\":{\"country_name\":\"Hong Kong SAR\",\"currency_code\":\"HKD\",\"currency_sign\":\"HK$\"},\"HN\":{\"country_name\":\"Honduras\",\"currency_code\":\"HNL\",\"currency_sign\":\"L\"},\"HR\":{\"country_name\":\"Croatia\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"HT\":{\"country_name\":\"Haiti\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"HU\":{\"country_name\":\"Hungary\",\"currency_code\":\"HUF\",\"currency_sign\":\"Ft\"},\"ID\":{\"country_name\":\"Indonesia\",\"currency_code\":\"IDR\",\"currency_sign\":\"Rp\"},\"IE\":{\"country_name\":\"Ireland\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"IL\":{\"country_name\":\"Israel\",\"currency_code\":\"ILS\",\"currency_sign\":\"₪\"},\"IM\":{\"country_name\":\"Isle of Man\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"IN\":{\"country_name\":\"India\",\"currency_code\":\"INR\",\"currency_sign\":\"₹\"},\"IO\":{\"country_name\":\"British Indian Ocean Territory\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"IQ\":{\"country_name\":\"Iraq\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"IS\":{\"country_name\":\"Iceland\",\"currency_code\":\"ISK\",\"currency_sign\":\"kr\"},\"IT\":{\"country_name\":\"Italy\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"JE\":{\"country_name\":\"Jersey\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"JM\":{\"country_name\":\"Jamaica\",\"currency_code\":\"JMD\",\"currency_sign\":\"$\"},\"JO\":{\"country_name\":\"Jordan\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"JP\":{\"country_name\":\"Japan\",\"currency_code\":\"JPY\",\"currency_sign\":\"¥\"},\"KE\":{\"country_name\":\"Kenya\",\"currency_code\":\"KES\",\"currency_sign\":null},\"KG\":{\"country_name\":\"Kyrgyzstan\",\"currency_code\":\"KGS\",\"currency_sign\":null},\"KH\":{\"country_name\":\"Cambodia\",\"currency_code\":\"KHR\",\"currency_sign\":\"៛\"},\"KI\":{\"country_name\":\"Kiribati\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"KM\":{\"country_name\":\"Comoros\",\"currency_code\":\"KMF\",\"currency_sign\":\"CF\"},\"KN\":{\"country_name\":\"St. Kitts & Nevis\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"KR\":{\"country_name\":\"South Korea\",\"currency_code\":\"KRW\",\"currency_sign\":\"₩\"},\"KW\":{\"country_name\":\"Kuwait\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"KY\":{\"country_name\":\"Cayman Islands\",\"currency_code\":\"KYD\",\"currency_sign\":\"$\"},\"KZ\":{\"country_name\":\"Kazakhstan\",\"currency_code\":\"KZT\",\"currency_sign\":\"₸\"},\"LA\":{\"country_name\":\"Laos\",\"currency_code\":\"LAK\",\"currency_sign\":\"₭\"},\"LB\":{\"country_name\":\"Lebanon\",\"currency_code\":\"LBP\",\"currency_sign\":\"L£\"},\"LC\":{\"country_name\":\"St. Lucia\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"LI\":{\"country_name\":\"Liechtenstein\",\"currency_code\":\"CHF\",\"currency_sign\":null},\"LK\":{\"country_name\":\"Sri Lanka\",\"currency_code\":\"LKR\",\"currency_sign\":\"Rs\"},\"LR\":{\"country_name\":\"Liberia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"LS\":{\"country_name\":\"Lesotho\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"LT\":{\"country_name\":\"Lithuania\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"LU\":{\"country_name\":\"Luxembourg\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"LV\":{\"country_name\":\"Latvia\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"LY\":{\"country_name\":\"Libya\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"MA\":{\"country_name\":\"Morocco\",\"currency_code\":\"MAD\",\"currency_sign\":null},\"MC\":{\"country_name\":\"Monaco\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"MD\":{\"country_name\":\"Moldova\",\"currency_code\":\"MDL\",\"currency_sign\":null},\"ME\":{\"country_name\":\"Montenegro\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"MF\":{\"country_name\":\"St. Martin\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"MG\":{\"country_name\":\"Madagascar\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"MK\":{\"country_name\":\"North Macedonia\",\"currency_code\":\"MKD\",\"currency_sign\":null},\"ML\":{\"country_name\":\"Mali\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"MM\":{\"country_name\":\"Myanmar (Burma)\",\"currency_code\":\"MMK\",\"currency_sign\":\"K\"},\"MN\":{\"country_name\":\"Mongolia\",\"currency_code\":\"MNT\",\"currency_sign\":\"₮\"},\"MO\":{\"country_name\":\"Macao SAR\",\"currency_code\":\"MOP\",\"currency_sign\":null},\"MQ\":{\"country_name\":\"Martinique\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"MR\":{\"country_name\":\"Mauritania\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"MS\":{\"country_name\":\"Montserrat\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"MT\":{\"country_name\":\"Malta\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"MU\":{\"country_name\":\"Mauritius\",\"currency_code\":\"MUR\",\"currency_sign\":\"Rs\"},\"MV\":{\"country_name\":\"Maldives\",\"currency_code\":\"MVR\",\"currency_sign\":null},\"MW\":{\"country_name\":\"Malawi\",\"currency_code\":\"MWK\",\"currency_sign\":null},\"MX\":{\"country_name\":\"Mexico\",\"currency_code\":\"MXN\",\"currency_sign\":\"$\"},\"MY\":{\"country_name\":\"Malaysia\",\"currency_code\":\"MYR\",\"currency_sign\":\"RM\"},\"MZ\":{\"country_name\":\"Mozambique\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"NA\":{\"country_name\":\"Namibia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"NC\":{\"country_name\":\"New Caledonia\",\"currency_code\":\"XPF\",\"currency_sign\":\"CFPF\"},\"NE\":{\"country_name\":\"Niger\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"NF\":{\"country_name\":\"Norfolk Island\",\"currency_code\":\"AUD\",\"currency_sign\":\"$\"},\"NG\":{\"country_name\":\"Nigeria\",\"currency_code\":\"NGN\",\"currency_sign\":\"₦\"},\"NI\":{\"country_name\":\"Nicaragua\",\"currency_code\":\"NIO\",\"currency_sign\":\"C$\"},\"NL\":{\"country_name\":\"Netherlands\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"NO\":{\"country_name\":\"Norway\",\"currency_code\":\"NOK\",\"currency_sign\":\"kr\"},\"NP\":{\"country_name\":\"Nepal\",\"currency_code\":\"NPR\",\"currency_sign\":\"Rs\"},\"NR\":{\"country_name\":\"Nauru\",\"currency_code\":\"AUD\",\"currency_sign\":\"$\"},\"NU\":{\"country_name\":\"Niue\",\"currency_code\":\"NZD\",\"currency_sign\":\"$\"},\"NZ\":{\"country_name\":\"New Zealand\",\"currency_code\":\"NZD\",\"currency_sign\":\"$\"},\"OM\":{\"country_name\":\"Oman\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"PA\":{\"country_name\":\"Panama\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"PE\":{\"country_name\":\"Peru\",\"currency_code\":\"PEN\",\"currency_sign\":null},\"PF\":{\"country_name\":\"French Polynesia\",\"currency_code\":\"XPF\",\"currency_sign\":\"CFPF\"},\"PG\":{\"country_name\":\"Papua New Guinea\",\"currency_code\":\"PGK\",\"currency_sign\":null},\"PH\":{\"country_name\":\"Philippines\",\"currency_code\":\"PHP\",\"currency_sign\":\"₱\"},\"PK\":{\"country_name\":\"Pakistan\",\"currency_code\":\"PKR\",\"currency_sign\":\"Rs\"},\"PL\":{\"country_name\":\"Poland\",\"currency_code\":\"PLN\",\"currency_sign\":\"zł\"},\"PM\":{\"country_name\":\"St. Pierre & Miquelon\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"PN\":{\"country_name\":\"Pitcairn Islands\",\"currency_code\":\"NZD\",\"currency_sign\":\"$\"},\"PS\":{\"country_name\":\"Palestinian Territories\",\"currency_code\":\"ILS\",\"currency_sign\":\"₪\"},\"PT\":{\"country_name\":\"Portugal\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"PR\":{\"country_name\":\"Puerto Rico\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"PY\":{\"country_name\":\"Paraguay\",\"currency_code\":\"PYG\",\"currency_sign\":\"₲\"},\"QA\":{\"country_name\":\"Qatar\",\"currency_code\":\"QAR\",\"currency_sign\":null},\"RE\":{\"country_name\":\"Réunion\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"RO\":{\"country_name\":\"Romania\",\"currency_code\":\"RON\",\"currency_sign\":\"lei\"},\"RS\":{\"country_name\":\"Serbia\",\"currency_code\":\"RSD\",\"currency_sign\":null},\"RU\":{\"country_name\":\"Russia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"RW\":{\"country_name\":\"Rwanda\",\"currency_code\":\"RWF\",\"currency_sign\":\"RF\"},\"SA\":{\"country_name\":\"Saudi Arabia\",\"currency_code\":\"SAR\",\"currency_sign\":null},\"SB\":{\"country_name\":\"Solomon Islands\",\"currency_code\":\"SBD\",\"currency_sign\":\"$\"},\"SC\":{\"country_name\":\"Seychelles\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"SD\":{\"country_name\":\"Sudan\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"SE\":{\"country_name\":\"Sweden\",\"currency_code\":\"SEK\",\"currency_sign\":\"kr\"},\"SG\":{\"country_name\":\"Singapore\",\"currency_code\":\"SGD\",\"currency_sign\":\"$\"},\"SH\":{\"country_name\":\"St. Helena\",\"currency_code\":\"SHP\",\"currency_sign\":\"£\"},\"SI\":{\"country_name\":\"Slovenia\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"SJ\":{\"country_name\":\"Svalbard & Jan Mayen\",\"currency_code\":\"NOK\",\"currency_sign\":\"kr\"},\"SK\":{\"country_name\":\"Slovakia\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"SL\":{\"country_name\":\"Sierra Leone\",\"currency_code\":\"SLL\",\"currency_sign\":null},\"SM\":{\"country_name\":\"San Marino\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"SN\":{\"country_name\":\"Senegal\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"SO\":{\"country_name\":\"Somalia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"SR\":{\"country_name\":\"Suriname\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"SS\":{\"country_name\":\"South Sudan\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"ST\":{\"country_name\":\"São Tomé & Príncipe\",\"currency_code\":\"STD\",\"currency_sign\":null},\"SV\":{\"country_name\":\"El Salvador\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"SX\":{\"country_name\":\"Sint Maarten\",\"currency_code\":\"ANG\",\"currency_sign\":null},\"SZ\":{\"country_name\":\"Eswatini\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"TA\":{\"country_name\":\"Tristan da Cunha\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"TC\":{\"country_name\":\"Turks & Caicos Islands\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"TD\":{\"country_name\":\"Chad\",\"currency_code\":\"XAF\",\"currency_sign\":\"FCFA\"},\"TF\":{\"country_name\":\"French Southern Territories\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"TG\":{\"country_name\":\"Togo\",\"currency_code\":\"XOF\",\"currency_sign\":\"F CFA\"},\"TH\":{\"country_name\":\"Thailand\",\"currency_code\":\"THB\",\"currency_sign\":\"฿\"},\"TJ\":{\"country_name\":\"Tajikistan\",\"currency_code\":\"TJS\",\"currency_sign\":null},\"TK\":{\"country_name\":\"Tokelau\",\"currency_code\":\"NZD\",\"currency_sign\":\"$\"},\"TL\":{\"country_name\":\"Timor-Leste\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"TM\":{\"country_name\":\"Turkmenistan\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"TN\":{\"country_name\":\"Tunisia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"TO\":{\"country_name\":\"Tonga\",\"currency_code\":\"TOP\",\"currency_sign\":\"T$\"},\"TR\":{\"country_name\":\"Turkey\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"TT\":{\"country_name\":\"Trinidad & Tobago\",\"currency_code\":\"TTD\",\"currency_sign\":\"$\"},\"TV\":{\"country_name\":\"Tuvalu\",\"currency_code\":\"AUD\",\"currency_sign\":\"$\"},\"TW\":{\"country_name\":\"Taiwan\",\"currency_code\":\"TWD\",\"currency_sign\":\"$\"},\"TZ\":{\"country_name\":\"Tanzania\",\"currency_code\":\"TZS\",\"currency_sign\":null},\"UA\":{\"country_name\":\"Ukraine\",\"currency_code\":\"UAH\",\"currency_sign\":\"₴\"},\"UG\":{\"country_name\":\"Uganda\",\"currency_code\":\"UGX\",\"currency_sign\":null},\"UM\":{\"country_name\":\"U.S. Outlying Islands\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"VI\":{\"country_name\":\"U.S. Virgin Islands\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"US\":{\"country_name\":\"United States\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"UY\":{\"country_name\":\"Uruguay\",\"currency_code\":\"UYU\",\"currency_sign\":\"$\"},\"UZ\":{\"country_name\":\"Uzbekistan\",\"currency_code\":\"UZS\",\"currency_sign\":null},\"VA\":{\"country_name\":\"Vatican City\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"VC\":{\"country_name\":\"St. Vincent & Grenadines\",\"currency_code\":\"XCD\",\"currency_sign\":\"$\"},\"VE\":{\"country_name\":\"Venezuela\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"VG\":{\"country_name\":\"British Virgin Islands\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"},\"VN\":{\"country_name\":\"Vietnam\",\"currency_code\":\"VND\",\"currency_sign\":\"₫\"},\"VU\":{\"country_name\":\"Vanuatu\",\"currency_code\":\"VUV\",\"currency_sign\":null},\"WF\":{\"country_name\":\"Wallis & Futuna\",\"currency_code\":\"XPF\",\"currency_sign\":\"CFPF\"},\"WS\":{\"country_name\":\"Samoa\",\"currency_code\":\"WST\",\"currency_sign\":null},\"XK\":{\"country_name\":\"Kosovo\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"YE\":{\"country_name\":\"Yemen\",\"currency_code\":\"YER\",\"currency_sign\":null},\"YT\":{\"country_name\":\"Mayotte\",\"currency_code\":\"EUR\",\"currency_sign\":\"€\"},\"ZA\":{\"country_name\":\"South Africa\",\"currency_code\":\"ZAR\",\"currency_sign\":\"R\",\"languages\":[\"en\"]},\"ZM\":{\"country_name\":\"Zambia\",\"currency_code\":\"GBP\",\"currency_sign\":\"£\"},\"ZW\":{\"country_name\":\"Zimbabwe\",\"currency_code\":\"USD\",\"currency_sign\":\"$\"}}")

          // Sort the object inside object.
          let sortedMap = $this.sort(data_countries, val => val.country_name );
          // Convert to object.
          let data_countries_sorted = {};
          sortedMap.forEach((v,k) => {
            data_countries_sorted[k] = v
          });

          if(currenciesByCountryCode[current_code].symbol){
            current_simbol = ' ' + currenciesByCountryCode[current_code].symbol;
          }
          let popup_show_countries = 'Australia,Austria,Belgium,Brazil,Brunei,Bulgaria,Canada,Chile,Cayman Islands,Costa Rica,Czechia,Denmark,Finland,France,Germany,Greece,Hong Kong SAR,Hungary,Iceland,Ireland,Israel,Italy,Jersey,Japan,Malaysia,Maldives,Mexico,Netherlands,New Zealand,Norway,Philippines,Poland,Portugal,Puerto Rico,Saudi Arabia,Singapore,Slovakia,South Africa,South Korea,Spain,Sweden,Switzerland,Thailand,U.S. Virgin Islands,United Arab Emirates,United Kingdom';
          let popup_variant_countries = 'Australia,Austria,Belgium,Brazil,Brunei,Bulgaria,Canada,Chile,Cayman Islands,Costa Rica,Czechia,Denmark,Finland,France,Germany,Greece,Hong Kong SAR,Hungary,Iceland,Ireland,Israel,Italy,Jersey,Japan,Malaysia,Maldives,Mexico,Netherlands,New Zealand,Norway,Philippines,Poland,Portugal,Puerto Rico,Saudi Arabia,Singapore,Slovakia,South Africa,South Korea,Spain,Sweden,Switzerland,Thailand,U.S. Virgin Islands,United Arab Emirates,United Kingdom,United States';
          if(popup_show_countries.indexOf(current_country) > -1){
            let flag_img = $this.getFlagImg(current_code);
            let LocaleBar = {
              suggestions,
              "messages": {
                "title": `Your location is set to`,
                "submit": "Continue",
                "change_country": "Change country",
                "change_language": "Change language",
                "change_country_and_language": "Change country and language",
                "cancel": "Cancel",
                "benefits": {
                  "shipping_options": `Get shipping options for ${current_country}`,
                  "local_currency": `Shop in ${currenciesByCountryCode[current_code].isoCode}${current_simbol}`
                }
              }
            };
            let localBar_preview_content = `<div class="preview-content content-wrap active"><div class="recommendation-modal__flag">
            <input class="hidden current-currency preview-current-currency" value="${currenciesByCountryCode[current_code].isoCode}">
            <img src="${flag_img}" width="75" height="48" alt="flag">
            </div>
            <h2 class="recommendation-modal__message">${LocaleBar.messages.title} <span class="recommendation-modal__message--bold">${current_country}</span></h2>
            <div class="recommendation-modal__benefits">
            <ul> 
            <li>${LocaleBar.messages.benefits.local_currency}</li>
            </ul>
            </div>
            <div class="recommendation-modal__form" data-country="${current_code}">
            <button class="recommendation-modal__button apply-btn" type="button">${LocaleBar.messages.submit}</button>
            </div>
            <button class="recommendation-modal__button--minimal change-btn" type="button">${LocaleBar.messages.change_country}</button></div>`;
            let country_option = '';
            for (let data_country in data_countries_sorted) {
              let simbol = '';
              let code = data_countries_sorted[data_country].currency_code;
              let country = data_countries_sorted[data_country].country_name;
              if(data_countries_sorted[data_country].currency_sign){
                simbol = ' ' + data_countries_sorted[data_country].currency_sign;
              }
              if(popup_variant_countries.indexOf(country) > -1){
                country_option += `<option value="${data_country}" data-cur="${code}" ${ data_country == current_code ? 'selected' : ''}>${country} (${code}${simbol})</option>`
              }
            }

            let localBar_change_content = `<div class="change-content content-wrap">
            <input class="hidden current-currency select-cur" value="${currenciesByCountryCode[current_code].isoCode}">
            <h2 class="recommendation-modal__message--align-start">${LocaleBar.messages.change_country}</h2>
            <div class="recommendation-modal__form">
            <div class="recommendation-modal__selector-wrapper--flag" style="background-image:url('${flag_img}')">
            <select class="recommendation-modal__selector--flag" name="country_code">${country_option}</select>
            </div>
            <button class="recommendation-modal__button apply-btn" type="button">${LocaleBar.messages.submit}</button>
            </div>
            <button class="recommendation-modal__button--minimal change-btn" type="button">${LocaleBar.messages.cancel}</button>
            </div></div>`;
            document.querySelector('.recommendation-modal__content').innerHTML = localBar_preview_content + localBar_change_content;
            $this.initElements();
            $this.backdrop.classList.add('active');
            $this.classList.add('active');
          }
        });
    }else{
      if(getCookie("currentCurrency")){
        //this.checkCurrency(this.currencySelector, this.shopCurrency);
      }
    }

  }
  initElements(){
    document.querySelectorAll('.change-btn').forEach(btn => btn.addEventListener('click', this.changePopupContent.bind(this)));
    document.querySelector('.recommendation-modal__selector--flag').addEventListener('change', this.changeSelect.bind(this));
    document.querySelectorAll('.content-wrap .apply-btn').forEach(btn => btn.addEventListener('click', this.applyCarrency.bind(this)));
    document.querySelectorAll('.recommendation-modal__close-button').forEach(btn => btn.addEventListener('click', this.applyCarrency.bind(this)));
  }
  getFlagImg(country) {
    if (country)
      return "https://cdn.shopify.com/static/images/flags/".concat(country.toLowerCase(), ".svg")
  }
  changeSelect(ev){
    let new_country = ev.currentTarget.value;
    let new_flag = this.getFlagImg(new_country);
    document.querySelector('.select-cur').value = ev.currentTarget.querySelector('option[value="'+ new_country +'"]').getAttribute('data-cur');
    ev.currentTarget.parentElement.style = `background-image:url('${new_flag}')`
  }
  changePopupContent(){
    document.querySelectorAll('.content-wrap').forEach((wrap) => {
      wrap.classList.toggle('active');
    });
  }

  applyCarrency(ev){
    console.log('applyCarrency');
    let new_cur;
    if(ev.currentTarget.classList.contains('recommendation-modal__close-button')){
      new_cur = document.querySelector('.preview-current-currency').value;
    }else{
      new_cur = document.querySelector('.content-wrap.active .current-currency').value;
    }
    setCookie("currentCurrency", new_cur, { expires: 'session' });
    setCookie("locale_bar_hidden", 1 , { expires: 'session' });
    this.classList.remove('active');
    this.backdrop.classList.remove('active');
    this.checkCurrency(this.currencySelector, this.shopCurrency);
  }
  sort(obj,valSelector) {
    const sortedEntries = Object.entries(obj)
      .sort((a, b) =>
        valSelector(a[1]) > valSelector(b[1]) ? 1 :
          valSelector(a[1]) < valSelector(b[1]) ? -1 : 0);
    return new Map(sortedEntries);
  }
  checkCurrency($currencySelector, shopCurrency){
    /* Cookie currency */
    var cookieCurrency = getCookie("currentCurrency");

    /* Saving the current price */

    document.querySelectorAll('.price-with-custom-currency').forEach(el=> el.setAttribute('data-currency-' + shopCurrency , el.textContent.trim()) );

    // If there's no cookie.
    if (!cookieCurrency || cookieCurrency == null) {
      Currency.currentCurrency = shopCurrency;
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if ($currencySelector.length && $currencySelector.querySelector('option[value=' + cookieCurrency + ']').length === 0) {
      Currency.currentCurrency = shopCurrency;
      setCookie("currentCurrency", shopCurrency, { expires: 'session' });
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
    } else {
      let btn_cur = document.querySelector('.btn-choose-currency');
      btn_cur.querySelector('.multi-picker__label').innerHTML = cookieCurrency;
      document.querySelector('.mob-picker__label').innerHTML = cookieCurrency;
      Currency.convertAll(shopCurrency, cookieCurrency);
      $currencySelector.value = cookieCurrency;
      $currencySelector.dispatchEvent(new Event('change'));
    }
  };
}



document.addEventListener('DOMContentLoaded', function() {

  // Sendy Subscribe
  let newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      let email = form.querySelector('input[name="email"]').value;
      let action = form.getAttribute("action");
      let url = form.querySelector('input[name="url"]').value;
      let param = {
        email: email,
        url: url
      }
      if (email == "") {
        form.nextElementSibling.querySelector(".newsletter-thanks-message").innerHTML = "Please enter email address!";
      } else {
        form.nextElementSibling.querySelector(".newsletter-thanks-message").innerHTML = "Subscribing...";
        form.classList.add('hidden');
        fetch(action, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(param),
        }).then(response => response.json()).then(response => {
          if (response.success) {
            if (response.message == "Invalid email address.") {
              form.classList.remove('hidden');
              form.nextElementSibling.querySelector(".newsletter-thanks-message").innerHTML = "Please enter a valid email.";
            }else if (response.message == "Already subscribed.") {
              form.nextElementSibling.querySelector(".newsletter-thanks-message").innerHTML = "You're already subscribed!";
            } else {
              form.nextElementSibling.querySelector(".newsletter-thanks-message").innerHTML = "Thank you, you're subscribed!";
            }
          } else {
            form.classList.remove('hidden');
            form.nextElementSibling.querySelector(".newsletter-thanks-message").innerHTML = "";
          }
        } )

      }
    });
  });

  let location_popup = document.querySelector('.recommendation-modal__container');
  if(location_popup){
    customElements.define('location-popup', LocationPopup);
  }

  let coll = document.querySelectorAll(".collapsible-btn");
  coll.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      btn.classList.toggle("active");
    });
  });


});

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if(c.indexOf(name) == 0)
      return c.substring(name.length,c.length);
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function findAncestor (el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}